export const INTERNAL_USE_ONLY = 'This API endpoint is for internal use only and may change in the future';
